/**
 * ZON-275 — when this user last opened the Notifications page, remembered in
 * this browser only (Bryan, Oct 2: no server-side read state). The nav dot
 * shows when something was added to the feed after that. Per device: opening
 * the page on a phone does not clear the dot on a laptop.
 */
export const SCHOOL_NEWS_SEEN_EVENT = "recruitai:school-news-seen";

function storageKey(userId: string | null | undefined): string {
  return `recruitai:school-news:last-seen:${userId || "anonymous"}`;
}

/** ISO time of the last visit, or null (never visited, or storage unavailable). */
export function getLastSeen(userId: string | null | undefined): string | null {
  try {
    return localStorage.getItem(storageKey(userId));
  } catch {
    return null;
  }
}

/** Record a visit now and tell the rest of the app so the dot clears at once. */
export function markSeen(userId: string | null | undefined, now: Date = new Date()): void {
  try {
    localStorage.setItem(storageKey(userId), now.toISOString());
  } catch {
    // Private mode or blocked storage: the dot simply stays until the feed is quiet.
  }
  window.dispatchEvent(new Event(SCHOOL_NEWS_SEEN_EVENT));
}

/** Was something added to the feed after the last visit? */
export function hasUnseen(
  latestAddedAt: string | null | undefined,
  lastSeen: string | null | undefined
): boolean {
  if (!latestAddedAt) return false;
  const latest = new Date(latestAddedAt).getTime();
  if (Number.isNaN(latest)) return false;
  if (!lastSeen) return true;
  const seen = new Date(lastSeen).getTime();
  return Number.isNaN(seen) ? true : latest > seen;
}
